import LoginPage from "../pages/LoginPage";
import UserManagement from "../pages/UserManagement";
import Categories from "../pages/Categories";
import Project from "../pages/Project";
import Logo from "../pages/Logo";

// Portal (New Landing Page)
import Portal from "../pages/Portal";
import PortalKnowledge from "../pages/PortalKnowledge";
import PortalDigitalization from "../pages/PortalDigitalization";
import PortalEngineering from "../pages/PortalEngineering";

// Lesson Management pages
import LessonList from "../pages/LessonList";
import LessonForm from "../pages/LessonForm";
import LessonDetail from "../pages/LessonDetail";

// VA/VE Management pages
import VaVeList from "../pages/VaVeList";
import VaVeForm from "../pages/VaVeForm";
import VaVeDashboard from "../pages/VaVeDashboard";

// Public Dashboard pages
import LessonDashboard from "../pages/LessonDashboard";
import DashboardDetail from "../pages/DashboardDetail";

// Rgistrasi user pages
import Register from "../pages/Register";

// ==========================================
// IMPORT HALAMAN INOVASI 
// ==========================================
import InovasiInput from "../pages/InovasiInput";
import InovasiList from "../pages/InovasiList";

// Public routes (tidak perlu login)
export const publicRoutes = [
  {
    path: "/login",
    element: LoginPage,
  },
  {
    path: "/dashboard",
    element: Portal,
  },
  {
    path: "/dashboard/lessons",
    element: LessonDashboard,
  },
  {
    path: "/dashboard/lessons/:id",
    element: DashboardDetail,
  },
  {
    path: "/dashboard/vave",
    element: VaVeDashboard,
  },
  {
    path: "/register",
    element: Register,
  },  
];

// Protected routes (perlu login - accessible by all authenticated users)
export const protectedRoutes = [
  {
    path: "/",
    element: Portal, // Home = Portal Landing Page
  },
  {
    path: "/portalknowledge",
    element: PortalKnowledge,
  },
  {
    path: "/digitalizationmanagement",
    element: PortalDigitalization,
  
  },
  {
    path: "/engineeringtools",
    element: PortalEngineering,
  
  },
  // Lesson Management
  {
    path: "/lessons",
    element: LessonList,
  },
  {
    path: "/lessons/create",
    element: LessonForm,
  },
  {
    path: "/lessons/:id",
    element: LessonDetail,
  },
  {
    path: "/lessons/:id/edit",
    element: LessonForm,
  },
  // VA/VE Management
  {
    path: "/vave",
    element: VaVeList, // Internal List (for CRUD)
  },
  {
    path: "/vave/create",
    element: VaVeForm,
  },
  {
    path: "/vave/:id/edit",
    element: VaVeForm,
  },
  // Logo management - all authenticated users
  {
    path: "/logo",
    element: Logo,
  },
  // ==========================================
  // ROUTE MONITORING INOVASI
  // ==========================================
  {
    path: "/inovasi",
    element: InovasiList, // Tambahkan halaman tabel (List)
  },
  {
    path: "/inovasi/create",
    element: InovasiInput,
  },
];

// Admin-only routes (perlu login + admin role)
export const adminRoutes = [
  {
    path: "/user-management",
    element: UserManagement,
  },
  {
    path: "/categories",
    element: Categories,
  },
  {
    path: "/project",
    element: Project,
  },
];
